const SvgComputeandServers1 = (props) => (
  <>
    <defs />
    <path
      d="M288.38 32.03v-32M240.34 32.03v-32M192 32V0M95.62 32.03v-32M143.89 32.03v-32M288.57 384v-32M240.55 384v-32M192.26 384v-32M96.19 384v-32M144.2 384v-32M32 96.19H0M32 144.21H0M32 191.95H0M32 288.56H0M32 240.26H0M384 96.18h-32M384 144.2h-32M384 192.26h-32M384 288.56h-32M384 240.55h-32M32 32h320v320H32z"
      fill="none"
      stroke="#001d6c"
      strokeMiterlimit={10}
      strokeWidth="3px"
    />
    <path d="M112 112h160v160H112z" fill="none" stroke="#001d6c" strokeMiterlimit={10} strokeWidth="3px" />
    <circle cx={272} cy={112} r={8} fill="#0f62fe" strokeWidth={0} />
    <circle cx={112} cy={112} r={8} fill="#0f62fe" strokeWidth={0} />
    <circle cx={272} cy={272} r={8} fill="#0f62fe" strokeWidth={0} />
    <circle cx={112} cy={272} r={8} fill="#0f62fe" strokeWidth={0} />
  </>
);

export default SvgComputeandServers1;
